<div class="document-assignment-dialog">
    <div class="dialog-title">
        <h2>
            <i class="fa fa-user-cog mr-2"></i>
            Asignare Document
        </h2>
        <p class="subtitle">
            Document ID: {{ data.document.id_document }} - {{ data.document.template || 'Document generat' }}
        </p>
    </div>

    <div mat-dialog-content class="dialog-content">
        <div *ngIf="isLoading && !loading" class="loading-container">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p>Se încarcă operatorii disponibili...</p>
        </div>

        <div *ngIf="loading && !isLoading" class="loading-container">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p>Vă rugăm așteptați...</p>
        </div>

        <form [formGroup]="assignmentForm" *ngIf="!isLoading">
            <!-- Current Assignment Display -->
            <div *ngIf="data.document.has_assignment" class="current-assignment mb-3">
                <div class="alert alert-info">
                    <h6><i class="fa fa-info-circle mr-1"></i> Asignare curentă:</h6>
                    <div [innerHTML]="data.document.assignment_summary"></div>
                    <small class="text-muted d-block mt-1">
                        Tip: {{ data.document.assignment_type === 'auto' ? 'Automată' : 'Manuală' }}
                        <span *ngIf="data.document.assignment_date"> • {{ data.document.assignment_date |
                            date:'dd/MM/yyyy HH:mm' }}</span>
                    </small>
                </div>
            </div>

            <!-- Assignment Mode Selection -->
            <div class="form-group">
                <label class="form-label">
                    <i class="fa fa-cogs mr-1"></i>
                    Mod asignare
                </label>
                <mat-radio-group formControlName="assignment_mode" class="radio-group" color="primary">
                    <mat-radio-button value="existing" class="radio-option">
                        <span class="radio-text">
                            <strong>Din asignările existente</strong>
                            <small class="d-block text-muted">Selectează din operatorii deja asignați cererii</small>
                        </span>
                    </mat-radio-button>
                    <mat-radio-button value="custom" class="radio-option">
                        <span class="radio-text">
                            <strong>Asignare personalizată</strong>
                            <small class="d-block text-muted">Specifică manual direcție, compartiment și
                                operator</small>
                        </span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Existing Operators Selection -->
            <div *ngIf="assignmentMode === 'existing'">
                <div class="form-group mt-3">
                    <label for="selected_operator_id" class="form-label">
                        <i class="fa fa-users mr-2"></i>
                        Selectează operator din asignările existente
                    </label>
                    <mat-form-field>
                        <mat-select formControlName="selected_operator_id" (selectionChange)="onOperatorSelect()">
                            <mat-option [value]="-1">-- Alegeți operatorul --</mat-option>
                            <mat-option *ngFor="let operator of availableOperators$ | async" [value]="operator.id">
                                <div class="operator-option">
                                    <div class="operator-info d-flex align-items-center gap-2">
                                        <span class="badge badge-secondary mr-2">
                                            {{ operator.functie.name || 'Funcție necunoscută' }}
                                        </span>
                                        <strong>{{ operator.directie.name || 'Direcție necunoscută' }}</strong>
                                        <span *ngIf="operator.compartiment" class="text-muted"> / {{
                                            operator.compartiment.name }}</span>
                                    </div>
                                    <div *ngIf="operator.user" class="operator-user mt-1">
                                        <i class="fa fa-user mr-1"></i>
                                        <span class="badge badge-success">{{ operator.user.full_name }}</span>
                                    </div>
                                    <div *ngIf="!operator.user" class="operator-user mt-1">
                                        <span class="badge badge-light">Neasignat utilizator</span>
                                    </div>
                                </div>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Selected Operator Preview -->
                <div *ngIf="selectedOperator$ | async as selectedOp" class="selected-preview mt-3">
                    <div class="alert alert-light border">
                        <h4 class="mb-2"><i class="fa fa-eye mr-1"></i> Previzualizare asignare:</h4>
                        <div class="assignment-preview">
                            <span class="badge badge-secondary me-2">{{ selectedOp.functie.name }}</span>
                            <span class="badge badge-primary me-2">{{ selectedOp.directie.name }}</span>
                            <span *ngIf="selectedOp.compartiment" class="badge badge-info me-2">{{
                                selectedOp.compartiment.name }}</span>
                            <span *ngIf="selectedOp.user" class="badge badge-success">{{ selectedOp.user.full_name
                                }}</span>
                            <span *ngIf="!selectedOp.user" class="badge badge-warning">Funcție neasignată</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Assignment Fields -->
            <div *ngIf="assignmentMode === 'custom'">
                <div class="row">
                    <!-- Directie -->
                    <div class="col-md-12">
                        <mat-form-field class="w-100">
                            <mat-label>Direcție </mat-label>
                            <mat-select formControlName="assigned_directie_id" (openedChange)="onDirectieSelectClosed()"
                                (selectionChange)="onDirectieChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="assignmentForm.get('assigned_directie_id')?.invalid && assignmentForm.get('assigned_directie_id')?.touched">
                                Direcția este obligatorie
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <!-- Compartiment -->
                    <div class="col-md-12">
                        <mat-form-field class="w-100">
                            <mat-label>Compartiment</mat-label>
                            <mat-select formControlName="assigned_compartiment_id"
                                (openedChange)="onCompartimentSelectClosed()"
                                (selectionChange)="onCompartimentChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="compartimenteControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                    [value]="compartiment.id_compartiment">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <!-- User -->
                    <div class="col-md-12">
                        <mat-form-field class="w-100">
                            <mat-label>Operator</mat-label>
                            <mat-select (openedChange)="onUsersSelectClosed()" formControlName="assigned_user_id">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="usersControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                    {{ user.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <!-- Functie -->
                    <div class="col-md-12">
                        <mat-form-field class="w-100">
                            <mat-label>Funcție</mat-label>
                            <mat-select formControlName="assigned_functie_id" (openedChange)="onFunctieSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="functiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredFunctii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let functie of filteredFunctii" [value]="functie.id">
                                    {{ functie.name }}
                                    <span *ngIf="functie.acronym"> ({{ functie.acronym }})</span>
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="assignmentForm.get('assigned_functie_id')?.invalid && assignmentForm.get('assigned_functie_id')?.touched">
                                Funcția este obligatorie
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Assignment Notes -->
            <div class="form-group">
                <label for="assignment_notes" class="form-label">
                    <i class="fa fa-sticky-note mr-1"></i>
                    Observații asignare (opțional)
                </label>
                <textarea formControlName="assignment_notes" class="form-control" rows="3"
                    placeholder="Adăugați observații despre această asignare..."></textarea>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <div class="actions-left">
            <button *ngIf="data.document.has_assignment" type="button" class="btn btn-outline-danger"
                [disabled]="isSaving" (click)="onUnassign()">
                <i class="fa fa-user-times mr-1"></i>
                Elimină asignarea
            </button>
        </div>

        <div class="actions-right">
            <button type="button" class="btn btn-secondary mr-2" [disabled]="isSaving" (click)="onCancel()">
                <i class="fa fa-times mr-1"></i>
                Anulează
            </button>

            <button type="button" class="btn btn-success" [disabled]="assignmentForm.invalid || isSaving || isLoading"
                (click)="onSubmit()">
                <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
                <i *ngIf="!isSaving" class="fa fa-save mr-1"></i>
                {{ data.document.has_assignment ? 'Actualizează asignarea' : 'Asignează documentul' }}
            </button>
        </div>
    </div>
</div>